var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalPoint(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 23,
    viewBox: "0 0 46 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 10.5C26.4385 6.0485 25 4 23 4C21 4 19.5615 6.0485 16 10.5C12 15.5 11 17 5 17H23H41C35 17 34 15.5 30 10.5"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 10.5C26.4385 6.0485 25 4 23 4C21 4 19.5615 6.0485 16 10.5C12 15.5 11 17 5 17H23H41C35 17 34 15.5 30 10.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.5L14.8287 9.56291L14.8287 9.56296L16 10.5ZM31.1713 9.56291C29.4336 7.39103 28.1088 5.6685 26.9819 4.52692C25.8352 3.36522 24.6084 2.5 23 2.5V5.5C23.3916 5.5 23.8841 5.65903 24.8469 6.63446C25.8297 7.63 27.0049 9.15747 28.8287 11.4371L31.1713 9.56291ZM23 2.5C21.3916 2.5 20.1648 3.36522 19.0181 4.52692C17.8912 5.6685 16.5664 7.39103 14.8287 9.56291L17.1713 11.4371C18.9951 9.15747 20.1703 7.63 21.1531 6.63446C22.1159 5.65903 22.6084 5.5 23 5.5V2.5ZM14.8287 9.56296C12.7538 12.1566 11.6744 13.5393 10.4179 14.3769C9.2832 15.1334 7.88936 15.5 5 15.5V18.5C8.11064 18.5 10.2168 18.1166 12.0821 16.8731C13.8256 15.7107 15.2462 13.8434 17.1713 11.437L14.8287 9.56296ZM5 18.5H23V15.5H5V18.5ZM23 18.5H41V15.5H23V18.5ZM41 15.5C38.1106 15.5 36.7168 15.1334 35.5821 14.3769C34.3256 13.5393 33.2462 12.1566 31.1713 9.56296L28.8287 11.437C30.7538 13.8434 32.1744 15.7107 33.9179 16.8731C35.7832 18.1166 37.8894 18.5 41 18.5V15.5Z",
    fill: "#EAEDF3",
    mask: "url(#path-1-inside-1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 46,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalPoint);
export default __webpack_public_path__ + "static/media/modalPoint.ded79bc3a7b3c9e65c361318df8a7f1f.svg";
export { ForwardRef as ReactComponent };